import type { GuestRegistrationData } from "~/domains/user/types/GuestRegistrationData";

export interface GuestRegistrationSource {
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  phone: string;
  line1: string;
  additionalLine1: string | null;
  zipCode: string;
  city: string;
  country: string;
  salutationCode: string;
  titleCode: string;
}

export function toGuestRegistrationData(source: GuestRegistrationSource): GuestRegistrationData {
  return {
    firstName: source.firstName,
    lastName: source.lastName,
    companyName: source.company,
    email: source.email,
    phone: source.phone,
    line1: source.line1,
    line2: source.additionalLine1 ?? "",
    zipCode: source.zipCode,
    city: source.city,
    country: source.country,
    salutationCode: source.salutationCode,
    titleCode: source.titleCode,
  };
}
